import { useMemo, useState } from 'preact/hooks'

// @ts-check
/**
 *  @typedef {import("../types/reward").RewardTabs} RewardTabs
 */

/**
 * @type {RewardTabs[]}
 */
export const TABS = ['ACTIVE', 'PAST']

export const useIsExpired = () => {
  const [tab, setTab] = useState('ACTIVE')
  const timestamp = useMemo(() => new Date().getTime(), [])

  /**
   *
   * @param {RewardTabs} tab
   */
  const handleTab = (tab) => setTab(tab)

  return {
    timestamp,
    tab,
    handleTab
  }
}
